import { useEffect, useMemo, useState } from "react";
import {
  Box,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
  MenuItem,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Visibility as ViewIcon } from "@mui/icons-material";
import MaterialReactTable from "material-react-table";
import { ViewSoglie, useGetPatientServices } from "../../ServiceComponents";
import getColumns from "./TelemonitoraggiColumns";
import BarChartIcon from "@mui/icons-material/BarChart";
import { renderDateUTC } from "../../../utils/utils";
import {
  EmptyPaper,
  LoadingError,
  LoadingPaper,
} from "../../LoadingComponents";
import { usePutServiceById } from "../../ServiceComponents";
import { useRef } from "react";
import { useEditMode } from "../../EditableComponents";

export default function TelemonitoraggiPatient({ patient_id }) {
  // === misc ===
  const openInEditMode = useRef(false);

  // === ViewSoglie modal handling ===
  const [selectedService, setSelectedService] = useState(null);
  const [openViewSoglie, setOpenViewSoglie] = useState(false);
  const handleOpenViewSoglie = (service) => {
    setSelectedService(service);
    setQueryKey(["services", service]);
    setOpenViewSoglie(true);
  };
  const handleCloseViewSoglie = () => {
    setOpenViewSoglie(false);
  };

  // === web service queries/mutations ===
  const patientServicesQuery = useGetPatientServices(patient_id);
  const editServiceMutation = usePutServiceById();

  // === EditMode handling ===
  const {
    editMode,
    enterEditMode,
    cancelEditMode,
    confirmEditMode,
    updateEditState,
    setQueryKey,
  } = useEditMode({
    editModeEnabled: false,
    updateMutation: editServiceMutation,
    initialQueryKey: [],
  });

  const tableColumns = getColumns(editMode, updateEditState);

  return (
    <Box
      sx={{
        display: "block",
        margin: "auto",
        width: "90%",
      }}
    >
      <Dialog maxWidth="md" open={openViewSoglie}>
        <ViewSoglie
          service_id={selectedService}
          closeModal={handleCloseViewSoglie}
          _editMode={openInEditMode.current}
        />
      </Dialog>

      {patientServicesQuery.isLoading ? (
        <LoadingPaper />
      ) : patientServicesQuery.isError ? (
        <LoadingError error={patientServicesQuery.error} />
      ) : (
        patientServicesQuery.isSuccess &&
        (patientServicesQuery.data.services.length === 0 ? (
          <EmptyPaper
            message={"Nessun telemonitoraggio associato al paziente"}
          />
        ) : (
          <MaterialReactTable
            columns={tableColumns}
            data={patientServicesQuery.data?.services || []}
            enableColumnActions={false}
            enableColumnFilters={false}
            enablePagination={false}
            enableSorting={false}
            enableColumnResizing
            enableBottomToolbar={false}
            muiTableContainerProps={{
              sx: {
                overflowX: "hidden",
              },
            }}
            enableTopToolbar={false}
            muiTableBodyRowProps={{ hover: false }}
            muiTablePaperProps={{ elevation: 0 }}
            enableRowActions={true}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "Azioni" },
            }}
            positionActionsColumn="last"
            renderRowActionMenuItems={({ closeMenu, row, table }) => [
              <MenuItem
                key="soglie"
                onClick={() => {
                  handleOpenViewSoglie(row.original.id);
                  closeMenu();
                }}
              >
                <IconButton>
                  <BarChartIcon color="primary" />
                </IconButton>
                Vedi soglie
              </MenuItem>,

              <MenuItem
                key="edit_telemonitoraggio"
                onClick={() => {
                  setQueryKey(["services", row.original.id]);
                  if (editMode === row.original.id) confirmEditMode();
                  else enterEditMode(row.original.id);
                  closeMenu();
                }}
              >
                <IconButton>
                  <EditIcon
                    color={editMode === row.original.id ? "success" : "warning"}
                  />
                </IconButton>
                Modifica
              </MenuItem>,
            ]}
          />
        ))
      )}
    </Box>
  );
}
